import { dbService } from './db';
import { syncService } from './syncService';
import { NewActivity } from './newActivity';
import { NavLink, useLoaderData, useNavigate } from "react-router";
import React, { useRef, useState, useEffect, useMemo } from 'react';
import { userService } from './userService';

import {
  Transition,
  Button,
  Input,
  Field
} from '@headlessui/react';

import {
  Bars3Icon,
  UserCircleIcon,
  MagnifyingGlassIcon,
  XMarkIcon, CalendarIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';

import {
  PlusIcon
} from '@heroicons/react/24/solid';


import Moment from "moment";


let navigate = {};

export async function clientLoader({ params }) {
  let db = await dbService.createDB();
  let session = await userService.getSession();
  return { session };
}

export function Activity({ }) {
  const { session } = useLoaderData();
  const [onMyActivities, setOnMyActivities] = useState(true);
  const [search, setSearch] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);

  navigate = useNavigate();

  async function toggleOnMyActivities(newValue) {
    setOnMyActivities(newValue);
  }

  async function showSearch() {
    setSearch(true);
  }

  useEffect(() => {
    if (search && inputRef.current) {
      inputRef.current.focus();
    }
  }, [search]);

  return (
    <>
      <div className="bg-black items-center">
        <div className="">
          <div className="top-0 left-0 p-6">
            <img
              alt="PVS"
              src="/logo.svg"
              className="h-8"
            />
          </div>
          <NavLink to="/user">
            <div className="absolute top-0 right-0 p-6">
              <div className="flex text-center items-center">
                {session?.full_name}<UserCircleIcon className="h-8 pl-2"></UserCircleIcon>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="flex flex-col h-screen absolute top-20">
          <div>
            <div className="flex items-center h-16 pb-4 mx-4">
              {!search &&
                <>
                  <div className="items-center"><MagnifyingGlassIcon className="h-7 flex-1" onClick={() => showSearch()}></MagnifyingGlassIcon></div>
                  <div className="text-center text-5xl font-semibold flex-1 w-6">Activities</div>
                  <div className="items-center"><Bars3Icon className="h-7 flex-1" onClick={() => setShowMenu(true)}></Bars3Icon></div>
                </>
              }
              {search &&
                <div className="min-w-full  relative">
                  <Field >
                    <Input name="search"
                      type="text"
                      className="bg-white rounded-lg p-2 px-4 text-gray-800 min-w-full focus:outline-none"
                      placeholder='Customer number'
                      value={query || ""} onChange={(e) => setQuery(e.target.value)}
                      ref={inputRef} />
                    <Button onClick={() => { setSearch(false); setQuery('') }} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-800 hover:text-gray-700">
                      <XMarkIcon className="w-5 h-5" />
                    </Button>
                  </Field>
                </div>
              }
            </div>

            <Transition show={showMenu}>
              <div className="transition duration-200 ease-in fixed inset-0 bg-pvs-gray/50 z-50 data-closed:opacity-0 text-black">
                <div className="fixed top-40 right-5 bg-pvs-lightergray rounded-md">
                  <div className="flex flex-col">
                    <Button className="w-55 bg-pvs-lightgray m-2 p-2" onClick={(event) => navigate("/sales", { replace: true })}>Dashboard</Button>
                    <Button className="w-55 bg-pvs-lightgray m-2 p-2" onClick={(event) => setShowMenu(false)}>Activities</Button>
                  </div>
                </div>
              </div>
            </Transition>

          </div>
          <div className="overflow-scroll flex-1 pt-2">
            <Activities session={session} query={query}></Activities>
          </div>
        </div>
      </div>
    </>
  );
}

function Activities({ session, query }) {
  const [activities, setActivities] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const [reloadToggle, setReloadToggle] = useState('false');

  useEffect(() => {
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let activitiesInternal = []
      let db = await dbService.createDB();
      const tx = db.transaction("activities");
      let count = 0;

      if (query == '') {
        for await (const cursor of tx.store) {
          if (count == 10) {
            break;
          }
          activitiesInternal.push(cursor.value);
          count++;
        }
        setActivities(activitiesInternal);
      } else if (query.length > 2) {
        for await (const cursor of tx.store) {
          if (count == 10) {
            break;
          }

          if (cursor.value.customer_number.toLowerCase().includes(query.toLowerCase())) {
            activitiesInternal.push(cursor.value);
            count++;
          }

        }
        setActivities(activitiesInternal);
      }
    };
    fetchData();

  }, [query, reloadToggle]);

  function toggleNew() {
    setShowNew(!showNew);
  }

  function reload() {
    setReloadToggle(Date.now)
  }

  return (
    <>
      <div className="w-screen grid place-items-center py-1">
        {activities.map((activity) =>
        <ActivityTile activity={activity}></ActivityTile>
      )}
        {query}
      </div>

      <div
        onClick={toggleNew}
        className="z-51 fixed bottom-5 right-5 h-14 w-14 bg-pvs-red text-5xl font-semibold text-center rounded-full justify-center flex items-center cursor-pointer"
      >
        <PlusIcon
          className={`h-12 w-12 font-semibold transition-transform duration-500 ${showNew ? "rotate-[180deg]" : "rotate-0"}`}
        />
      </div>

      <NewActivity reload={reload} isOpen={showNew} setIsOpen={setShowNew}></NewActivity>
    </>

  )
}

function ActivityTile({ activity }) {

  const [customerName, setCustomerName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      let db = await dbService.createDB();
      let customer = await getFirstCustomerByNumber(db, activity.customer_number);
      console.log(activity.customer_number)
      console.log(customer)
      setCustomerName(customer.name)
    };
    fetchData();

  }, []);

  async function getFirstCustomerByNumber(db, customerNumber) {
    return await db.transaction('customers')
      .objectStore('customers')
      .index('customerNumberIndex')
      .get(customerNumber);
  }

  return (
    <div key={`act_${activity.activity_number}${Math.random().toString(36).substring(2, 6)}`} className="bg-pvs-lightgray w-9/10 min-h-38 rounded-md my-1 text-black">
      <div className="p-2 text-sm">
        <span className="font-semibold">{activity.activity_number} {customerName}</span><br></br>
        <span className="font-semibold text-lg">{activity.customer_number}</span>
        <div className="flex pb-2">
          <CalendarIcon className="text-pvs-gray h-5"></CalendarIcon>
          <span className="pl-1">{Moment(activity.end_date).format("MMMM D, YYYY")}</span>
          <InformationCircleIcon className="text-pvs-gray h-5 pl-2"></InformationCircleIcon>
          <span className="pl-1">{activity.purpose}</span>
        </div>
        {activity.user_memo &&
        <>
          <span className="font-semibold">Note</span><br></br>
          <div dangerouslySetInnerHTML={{ __html: activity.user_memo }} />
        </>
        }
      </div>
    </div>
  )
}
